'use client'

import classNames from 'classnames'
import { CHECKBOX_DOM_ID } from './consts'
import { InvisibleLoader, CheckboxLoader } from './loader'
import s from './style.module.css'

export type TFormStatus = string | null

const Recaptcha = ({ formStatus }: { formStatus: TFormStatus }) => {
	return (
		<>
			<div
				className={classNames(s.checkboxContainer, s[formStatus])}
				id={CHECKBOX_DOM_ID}
			/>
			<CheckboxLoader />
			<InvisibleLoader />
		</>
	)
}

export default Recaptcha
